var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 1.3,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.425 20.35C15.9064 20.35 20.35 15.9064 20.35 10.425C20.35 4.94357 15.9064 0.5 10.425 0.5C4.94357 0.5 0.5 4.94357 0.5 10.425C0.5 15.9064 4.94357 20.35 10.425 20.35Z",
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.021 17.034C3.95192 15.9909 5.09274 15.1563 6.36869 14.5849C7.64464 14.0134 9.02693 13.718 10.425 13.718C11.8231 13.718 13.2054 14.0134 14.4813 14.5849C15.7573 15.1563 16.8981 15.9909 17.829 17.034",
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8799 7.49597C14.8799 8.38599 14.616 9.25602 14.1215 9.99604C13.627 10.7361 12.9242 11.3128 12.102 11.6534C11.2797 11.994 10.3749 12.0831 9.50198 11.9095C8.62906 11.7359 7.82724 11.3073 7.1979 10.678C6.56857 10.0486 6.13998 9.24679 5.96635 8.37388C5.79272 7.50096 5.88183 6.59616 6.22243 5.7739C6.56302 4.95163 7.1398 4.24882 7.87982 3.75436C8.61984 3.25989 9.48987 2.99597 10.3799 2.99597C11.5734 2.99597 12.718 3.47008 13.5619 4.31399C14.4058 5.1579 14.8799 6.3025 14.8799 7.49597Z",
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cfe40c27fde82380ea029279a57a00b7.svg";
export { ForwardRef as ReactComponent };